import BannerCardFullWidthSection from '../BannerCardFullWidthSection'
import banner from 'assets/images/partners/travel-partner-banner.png'
import Carousel from 'components/carousels/Carousel'
import { ArrowRightIcon } from 'components/icons'
import { Pagination } from 'swiper/modules'

const TravelAgentApplyStep = ({
  title,
  description,
  index,
}: {
  title: string
  description: string
  index: number
}) => (
  <div className="flex flex-col items-center gap-20 lg:max-w-[300px] pt-20 pb-50 lg:pb-40" key={index}>
    <div className="font-serif bg-primary bg-opacity-50 ring-opacity-50 rounded-full w-100 h-100 text-center text-white text-50 font-bold border-white border ring-[8px] ring-primary pt-[12px]">
      {index + 1}
    </div>
    <div className="font-serif font-bold text-28 leading-title tracking-title mt-15">
      {title}
    </div>
    <div className="text-center text-grey-750 text-14 leading-23">
      {description}
    </div>
  </div>
)

const TravelAgentApplySection = ({
  onClick,
}: {
  onClick: () => void
}) => {
  const applySteps = [
    {
      title: 'Apply',
      description: 'Apply now and let us know a bit more about your business. We’ll get back to you within 48h via email.',
    },
    {
      title: 'Create Account',
      description: 'Create an account on the website, browse our portfolio across all destinations and explore the dashboard.',
    },
    {
      title: 'Book Travel',
      description: 'Send your inquiries directly on the website to receive handpicked properties from our villa specialists for your client requests.',
    },
  ]

  return (
    <>
      <BannerCardFullWidthSection
        bannerImage={banner}
        altText="A glass of wine on a chair by the ocean at sunset, creating a serene and relaxing ambiance."
        title="Apply as a travel advisor"
        subtitle="Partner with us"
        button={{
          text: <>
            <ArrowRightIcon /> Apply Now
          </>,
          onClick: onClick,
          className: '!mt-0',
        }}
      >
        <div className="lg:flex w-full justify-between mt-[65px] hidden">
          {
            applySteps.map(({ title, description }, index) => (<TravelAgentApplyStep title={title} description={description} index={index} key={index}/>))
          }
        </div>
        <div className="lg:hidden -mx-25 sm:-mx-[60px] overflow-hidden">
          <Carousel
            modules={[Pagination]}
            centeredSlides
            spaceBetween={30}
            slidesPerView={'auto'}
            className="h-full"
            pagination={{
              clickable: true,
            }}
            items={applySteps.map(({ title, description }, index) => (<TravelAgentApplyStep title={title} description={description} index={index} key={index}/>))}
          />
        </div>
      </BannerCardFullWidthSection>
    </>
  )
}
export default TravelAgentApplySection
